import { render, staticRenderFns } from "./IndexMessage.vue?vue&type=template&id=99ca179a&"
import script from "./IndexMessage.vue?vue&type=script&lang=js&"
export * from "./IndexMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\dev.marcdeloche.fr\\themes\\marcdeloche\\_dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('99ca179a', component.options)
    } else {
      api.reload('99ca179a', component.options)
    }
    module.hot.accept("./IndexMessage.vue?vue&type=template&id=99ca179a&", function () {
      api.rerender('99ca179a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/vuejs/components/Giftcard/IndexMessage.vue"
export default component.exports